import { useForm } from '@refinedev/antd';
import { Descriptions, Form, Input, Modal, Space } from 'antd';
import { ReferenceSelect } from '../../../components/form-item/ReferenceSelect';
import { useList, useOne } from '@refinedev/core';
import { IExperienceReservationSlot } from '../../../interfaces/experience';
import DatePicker from '../../../components/form-item/DatePicker';

type Props = {
  editId?: string;
  onClose: () => void;
};

const fields = ['id', 'eventId', 'reservationSlotId', 'date', 'startTime', 'endTime'];

export const EditDialog = ({ editId, onClose }: Props) => {
  const { formProps, form } = useForm({
    resource: 'experienceReservations',
    id: editId,
    action: 'edit',
    meta: {
      fields,
    },
    mutationMeta: {
      fields: [
        {
          experienceReservation: fields,
        },
      ],
    },
  });
  const eventId = Form.useWatch('eventId', form);
  const slotId = Form.useWatch('reservationSlotId', form);
  const { data: selectedSlot } = useOne<IExperienceReservationSlot>({
    resource: 'experienceReservationSlots',
    id: slotId,
    meta: {
      fields: [
        'id',
        'name',
        'plan',
        'place',
        'date',
        'startTime',
        'endTime',
        'capacity',
        'available',
        'reservedSeatCount',
      ],
    },
  });

  const handleSubmit = () => {
    form.submit();
    onClose();
  };

  return (
    <Modal open={!!editId} title="予約の変更" onCancel={onClose} onOk={handleSubmit} width={800}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="イベント" name="eventId">
          <ReferenceSelect label="イベント" optionLabel="name" resource="experienceEvents" />
        </Form.Item>
        <Form.Item label="予約枠" name="reservationSlotId">
          <ReferenceSelect
            label="予約枠"
            optionLabel="name"
            resource="experienceReservationSlots"
            filters={[
              {
                field: 'eventId',
                operator: 'eq',
                value: eventId,
              },
            ]}
          />
        </Form.Item>
        <Form.Item>
          <Space>
            <Form.Item
              label={`日付: ${selectedSlot?.data.date}`}
              name="date"
              style={{ width: 'max-content' }}
            >
              <Input type="date" />
            </Form.Item>
            <Form.Item label={`開始時間: ${selectedSlot?.data.startTime}`} name="startTime">
              <Input />
            </Form.Item>
            <Form.Item label={`終了時間: ${selectedSlot?.data.endTime}`} name="endTime">
              <Input />
            </Form.Item>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};
